import * as SharedMessageTypes from "../../../../darvin-shared/schema/zod/agent/message-types.schema";
import {
  ProjectChatAssistantMessage,
  ProjectChatElement,
  ProjectChatTemporaryUserMessage,
  ProjectChatUserMessage,
} from "../../../view_stores/chat_messages/chatModels";
import { ProjectAssistantErrorMessage } from "./messages/assistant/ProjectAssistantErrorMessage";
import { RollbackBtnProps } from "./messages/assistant/ProjectAssistantMessageBase";
import { ProjectAssistantUnifiedMessage } from "./messages/assistant/ProjectAssistantUnifiedMessage";
import { ProjectFilesGenerationMessage } from "./messages/ProjectFilesGenerationMessage";
import { ProjectUserMessage } from "./messages/ProjectUserMessage";

export const ProjectChatMessage = ({
  message,
  isLast,
  rollbackBtn,
}: {
  message: ProjectChatElement;
  isLast: boolean;
  rollbackBtn?: RollbackBtnProps;
}) => {
  const getComponent = () => {
    if (message instanceof ProjectChatUserMessage) {
      return (
        <ProjectUserMessage
          message={(message as ProjectChatUserMessage).value.message}
          attachments={
            (message as ProjectChatUserMessage).value.attachments ?? []
          }
          canBeAnimated={false}
        />
      );
    }

    if (message instanceof ProjectChatTemporaryUserMessage) {
      const attachedFile = (message as ProjectChatTemporaryUserMessage)
        .attachedFile;
      return (
        <ProjectUserMessage
          message={(message as ProjectChatTemporaryUserMessage).content}
          attachments={attachedFile ? [attachedFile] : []}
          canBeAnimated={true}
        />
      );
    }

    const assistantMsg = message as ProjectChatAssistantMessage;
    if (
      typeof assistantMsg.value === "object" &&
      "files" in assistantMsg.value
    ) {
      return <ProjectFilesGenerationMessage message={assistantMsg} />;
    }

    if (assistantMsg.type === SharedMessageTypes.MessageTypeEnum.Enum.error) {
      return (
        <ProjectAssistantErrorMessage
          message={assistantMsg}
          canFix={isLast}
          rollbackBtn={rollbackBtn}
        />
      );
    }

    return (
      <ProjectAssistantUnifiedMessage
        message={assistantMsg}
        rollbackBtn={rollbackBtn}
      />
    );
  };

  return getComponent();
};
